export default __webpack_public_path__ + "static/media/brief-placeholder.2651eb4e.svg";